// extracted by mini-css-extract-plugin
module.exports = {"bank_account":"styles_bank_account__PQwp-"};